export const pageLoaderElem = document.getElementsByClassName('page-loader-overlay')[0];
export const content = document.getElementsByClassName('container-fluid')[0];

// tslint:disable-next-line:typedef (autogenerated)
export async function getMainDiv() {
    if (content && content.parentNode) {
        content.parentNode.removeChild(content);
    }
    if (pageLoaderElem) {
        pageLoaderElem.className += ' page-loader-complete';

        // tslint:disable-next-line:typedef (autogenerated)
        setTimeout(function() {
            if (pageLoaderElem.parentNode) {
                pageLoaderElem.parentNode.removeChild(pageLoaderElem);
            }
        }, 1500);
    }

    let mainDiv = document.getElementById('react-main-app');
    if (!mainDiv) {
        mainDiv = document.createElement('div');
        mainDiv.id = 'react-main-app';
        document.body.appendChild(mainDiv);
    }

    mainDiv.style.position = 'absolute';
    mainDiv.style.width = '100%';
    mainDiv.style.height = '100%';
    mainDiv.style.top = '0';
    mainDiv.style.zIndex = '10';
    mainDiv.style.backgroundColor = 'white';

    return Promise.resolve(mainDiv);
}
